// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3RYN1","infoBtn":"quickbooks_infoBtn__12mNY","formBox":"quickbooks_formBox__1cVlb","formFooter":"quickbooks_formFooter__1waFH"};